module.exports = __webpack_public_path__ + "img/schedule20260919_1.9803128d.jpg";